<template>
  <article
    id="pc"
    v-bind:class="{
      fillScreenMode: showFullScreen,
      landscape: pageInfo.horizontal,
      bigsize: pageInfo.gameSize == 'big'
    }"
  >
    <PcHeader v-on:showAccount="showAccount"></PcHeader>

    <div class="pc-contianer">
      <div
        class="game-wrapper"
        v-bind:class="{
          jFillScreenPhone: showFullScreen,
          phone: !pageInfo.horizontal && pageInfo.gameSize == 'normal',
          ipad: pageInfo.horizontal && pageInfo.gameSize == 'normal'
        }"
        v-resize="showFullScreen"
        v-if="finishGameConf"
      >
        <aside
          class="platform-operas j-platform-operas"
          v-if="pageInfo.leftAside"
        >
          <div class="operas j-operas">
            <div class="ops j-ops-contianer">
              <div class="current-game j-current-game">
                您正在玩
                <p class="game-name j-game-name">{{ gameName }}</p>
              </div>
              <a
                class="ops-btn j-ops-btn j-website-btn"
                v-bind:href="gameSite"
                target="blank"
              >遊戲官網</a>
              <a
                class="ops-btn j-ops-btn j-download-btn"
                href="javascript:;"
                @click="downloadFn"
              >添加到桌面</a>
              <a
                class="ops-btn j-ops-btn j-support-btn"
                @click="jumpToSupport"
                href="javascript:;"
              >客服工單</a>
            </div>
          </div>
          <!-- 下载提示图片 -->
          <div
            class="tips j-tips"
            v-show="!isReview"
          ></div>
          <transition name="fade">
            <div
              class="add-desktop j-add-desktop"
              v-show="showDesktopTips"
            >
              <button
                class="close-add-desktop"
                v-on:click="clearAddDeskTopTips"
              ></button>
            </div>
          </transition>
        </aside>
        <button
          type="button"
          class="fill-screen-btn j-fill-screen-btn j-fullscreen"
          v-on:click="fullScreen"
          v-if="pageInfo.fullscreen || (pageInfo.headerScreen && showFullScreen)"
        ></button>
        <QrCode v-if="!isReview && pageInfo.rightQrcode"></QrCode>
        <GameIframe
          class="game-area j-mobile-page"
          ref="gameController"
        ></GameIframe>
      </div>
      <div
        class="bg"
        :style="bgCss"
      ></div>
    </div>
    <PcFooter></PcFooter>

    <GiftListPopup v-show="giftListPopupState"></GiftListPopup>
    <GiftGetPopup v-show="giftNumberGetPopupState"></GiftGetPopup>
  </article>
</template>

<style lang="scss">
@import "../../assets/scss/base.scss";
@import "../../assets/scss/pc.scss";
@import "../../assets/scss/pcHorizontal.scss";
</style>

<script>
import resize from "./directive/resize";
import GameIframe from "../../components/GameIframe";
import QrCode from "../../components/QrCode";
import GiftListPopup from "../../components/GiftListPopup";
import GiftGetPopup from "../../components/GiftGetPopup";
import PcFooter from "../../components/PcFooter";
import PcHeader from "../../components/PcHeader";
import { getHrefParam } from "../../store/ultile";
import { fbInit, fbShare } from "../../utile/fb";
import { generateFbHref } from "../../utile";
import dateFormat from "date.str.format";
import { isIE, iOSversion } from "../../utile/device";
import Download from "../../mixins/Download";
import Favour from "../../mixins/Favour";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "app",
  data() {
    return {
      srcindex: 0,
      // showFullScreen: false,
      saveState: false,
      popUpShow: false,
      showDesktopTips: false,
      ltIE10: false, //isIE()&&isIE()<11,
      gameName: window.gameName, //  全局smarty 输出
      gameSite: window.gameSite, //  全局smarty 输出
      // 有審查，臨時加的
      isReview:
        getHrefParam("game_id") === "44" && getHrefParam("cid") === "63",
    };
  },
  components: {
    GameIframe,
    QrCode,
    GiftListPopup,
    GiftGetPopup,
    PcFooter,
    PcHeader,
  },

  mixins: [Download, Favour],
  computed: {
    bgCss() {
      return `background-image:url(${this.pageInfo.bg});background-position:center;background-size: auto 100%;`;
    },
    ...mapGetters([
      "user",
      "pageInfo",
      "giftListPopupState",
      "giftNumberGetPopupState",
      "finishGameConf",
      "showFullScreen",
      'roleInfo'
    ]),
  },
  directives: {
    resize,
  },
  beforeCreate() {
    if (isIE() && isIE() < 11) {
      alert("使用IE11及以上版本瀏覽器就能獲得最佳遊戲體驗噢");
    }
  },
  created() {
    // 3分钟后展示提示添加桌面信息
    setTimeout(() => {
      var haveShowReacord = false;
      try {
        haveShowReacord = window.localStorage.getItem("showAddDEskTopReacord");
      } catch (e) {}
      var now = new Date();
      var timeStr = dateFormat(now, "yyyy-mm-dd");
      if (haveShowReacord !== timeStr) {
        this.showDesktopTips = true;
      }
    }, 1000 * 60 * 3);
    this.getGameConf();
  },
  methods: {
    fullScreen() {
      this.$store.commit("toggleFullScreenState");
      // this.showFullScreen = !this.showFullScreen;
    },

    showAccount(type) {
      this.$refs.gameController.openAccountPopup(type);
    },
    clearAddDeskTopTips() {
      var now = new Date();
      var timeStr = dateFormat(now, "yyyy-mm-dd");
      try {
        window.localStorage.setItem("showAddDEskTopReacord", timeStr);
      } catch (e) {}

      this.showDesktopTips = false;
    },
    jumpToSupport() {
      window.open(
        `//service.gm99.com/?isH5=1&pc=${window.isPhone ? 0 : 1}&gameId=${
          this.gameId
        }&serverId=${this.roleInfo.serverId}&roleId=${
          this.roleInfo.roleId
        }&roleName=${this.roleInfo.roleName}/#/wo`,
        "_blank"
      );
    },
    ...mapActions(["getGameConf"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/pc/App.vue